import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Typography,
  Box,
} from "@mui/material";
import { NavigateNext, Home } from "@mui/icons-material";
import { getBreadcrumbs } from "./routeConfig";

export default function Breadcrumbs() {
  const location = useLocation();
  const navigate = useNavigate();
  const crumbs = getBreadcrumbs(location.pathname);

  // Always show breadcrumbs (at minimum, the Home crumb)
  const hasCrumbs = crumbs.length >= 1;

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3 },
        py: hasCrumbs ? 1 : 0,
        bgcolor: "white",
        borderBottom: hasCrumbs ? "1px solid" : "none",
        borderColor: "divider",
        minHeight: hasCrumbs ? 40 : 0,
        overflow: "hidden",
        transition: "min-height 0.15s ease, padding 0.15s ease",
      }}
    >
      {hasCrumbs && (
        <MuiBreadcrumbs
          separator={<NavigateNext fontSize="small" sx={{ color: "text.disabled" }} />}
          sx={{ "& .MuiBreadcrumbs-li": { display: "flex", alignItems: "center" } }}
        >
          {crumbs.map((crumb, index) => {
            const isLast = index === crumbs.length - 1;
            const Icon = crumb.icon;

            if (isLast) {
              return (
                <Box key={crumb.path} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  {Icon && <Icon sx={{ fontSize: 16, color: "primary.main" }} />}
                  <Typography
                    variant="body2"
                    color="primary"
                    fontWeight={600}
                    sx={{ fontSize: "0.8rem" }}
                  >
                    {crumb.label}
                  </Typography>
                </Box>
              );
            }

            return (
              <Link
                key={crumb.path}
                component="button"
                variant="body2"
                underline="hover"
                color="text.secondary"
                onClick={() => navigate(crumb.path)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  fontSize: "0.8rem",
                  cursor: "pointer",
                  "&:hover": { color: "primary.main" },
                }}
              >
                {crumb.path === "/" ? (
                  <Home sx={{ fontSize: 16 }} />
                ) : (
                  Icon && <Icon sx={{ fontSize: 16 }} />
                )}
                {crumb.label}
              </Link>
            );
          })}
        </MuiBreadcrumbs>
      )}
    </Box>
  );
}
